import { FC } from 'react'
import image from '@/assets/img/temp.png'
import { TypeIcon } from '@/components/Atoms/Icons/types'

const Icon: FC<TypeIcon> = ({ width = 30, height = 30 }) => {
  return (
    <img
      src={image}
      alt='temp'
      width={width}
      height={height}
    />
  )
}

export default Icon
